// extracted by mini-css-extract-plugin
export default {"section5Wrapper":"Section5_section5Wrapper__4zLoM","partnerItem":"Section5_partnerItem__TJIXb","partnerLogo":"Section5_partnerLogo__6v2Qp"};